export default __webpack_public_path__ + "static/Contact_Us_BG-Gradient-68d414ac8cb3425d534358636ce8d001.png";